import { CircleInfoIcon, Switch, Tooltip } from "@xola/ui-kit";
import React from "react";

interface RetainPurchasePriceProps {
    isChecked: boolean;
    isVisible?: boolean;
    onChange: () => void;
}

export const PurchasePriceStrategy = ({ isChecked, isVisible = true, onChange }: RetainPurchasePriceProps) => {
    return isVisible ? (
        <div
            className="bg-warning-lighter flex w-full items-center space-x-2 whitespace-nowrap p-4"
            data-testid="purchase-price-strategy"
        >
            <Switch
                data-testid="purchase-price-strategy-switch"
                isChecked={isChecked}
                size="medium"
                onChange={onChange}
            />
            <div className="w-full flex-1">
                <span className="text-base font-bold text-black">Retain current price configuration</span>
                <Tooltip
                    content="If turned on, Xola will retain the current price configuration in this purchase. If turned off, Xola will use the latest price configuration from your product settings."
                    className="ml-1"
                >
                    <CircleInfoIcon />
                </Tooltip>
            </div>
        </div>
    ) : null;
};
